export default __webpack_public_path__ + "static/media/alarm-icon.2089b669.svg";